export default function () {
	return {
		query: '',
		total_quantity: null,
		results: {},
		products: [],
		search_products: [],
		suggestions: [],
		recent: [],
		show_preloader: false,
		show_empty: false,
		closed: false,

		get translatedSearchResults() {
			let translation = '';
			if (window.current_location === 'Deutschland') {
				translation = `Alle ${this.total_quantity} Treffer zeigen`;
			} else {
				translation = `Show all ${this.total_quantity} matches`;
			}

			return translation;
		},

		async initSearch() {
			this.closed = false;
			if (this.query.length > 1) {
				this.show_preloader = true;
				const url = `${window.routes.predictiveSearch}.json?q=${this.query}`;
				const response = await fetch(url);

				if (response.status !== 200) return;

				const json = await response.json();

				const results = json.resources.results;
				const search_url = `${Shopify.routes.root}search?q=${this.query}&view=ajax-search`;
				const search_responce = await fetch(search_url);
				const search_page_data = await search_responce.json();
				this.results = results;
				this.search_products = [];
				this.total_quantity = search_page_data.search_results;
				this.recent = search_page_data.items;
			}
		},

		async getProductData() {
			this.search_products = [];
			for (const product of this.products) {
				const url = `${Shopify.routes.root}products/${product.handle}?view=get-product-json`;
				const responce = await fetch(url);
				if (responce.status !== 200) return;
				const formated_product = await responce.json();
				if (!this.search_products.includes(formated_product)) {
					this.search_products.push(formated_product);
				}
			}
		},

		searchRecent(query) {
			window.location.href = `${Shopify.routes.root}search?q=${query}`;
		},

		searchAllResults() {
			window.location.href = `${Shopify.routes.root}search?q=${this.query}`;
		},

		getVariant(product) {
			if (product) {
				let current_variant = product.selected_or_first_available_variant;
				if (product.options[0] === 'Title') {
					current_variant = product.selected_or_first_available_variant;
				} else if (product.variants.length > 0 && product.options[0] === 'Volume') {
					const variant = product.variants.find((el) => this.getNumberFromString(el.title) > 10);
					current_variant = variant;
				} else if (product.variants.length > 0) {
					current_variant = product.variants[0];
				} else {
					current_variant = product.selected_or_first_available_variant;
				}

				return current_variant;
			}
		},

		getVolume(options) {
			if (options.name === 'Title') {
				return '';
			}
			if (options.name === 'Volume') {
				const title = options.values.find((el) => this.getNumberFromString(el) > 10);
				return title;
			}
		},

		getPrice(product, value, location) {
			let formatted_price = '';
			const variant = this.getVariant(product);

			if (variant) {
				if (location) {
					if (variant[value]) {
						formatted_price = Number(variant[value]).toFixed(2).replace('.', ',');
					}
				} else {
					formatted_price = Number(variant[value] / 100)
						.toFixed(2)
						.replace('.', ',');
				}
			}

			return formatted_price;
		},

		getUnitPrice(product) {
			const variant = this.getVariant(product);
			let unit_pice = '';
			const price = variant.unit_price;
			const unit = variant.unit_price_measurement.reference_unit;
			const value = variant.unit_price_measurement.reference_value;
			if (price && unit) {
				unit_pice = `(${(price / 100).toFixed(2).replace('.', ',')} ${
					window.Shopify.currency.active
				} / ${value}${unit})`;
			}

			return unit_pice;
		},

		getNumberFromString(string) {
			const formated_string = string.match(/\d+/);
			if (formated_string) {
				const nums = Number(formated_string[0]);
				if (nums) {
					return nums;
				}
			} else return '';
		},

		initClose(event) {
			this.closed = event.detail.closed;
			this.query = '';
			this.products = [];
			this.search_products = [];
			this.results = null;
			this.total_quantity = '';
			this.show_preloader = false;
			this.show_empty = false;
			this.recent = [];
		},

		init() {
			this.$watch('results', () => {
				if (this.results !== null && this.results.products.length > 0) {
					this.products = this.results.products;
				} else {
					this.products = [];
				}
				if (this.results !== null && this.results.queries.length > 0) {
					this.suggestions = this.results.queries;
				} else {
					this.suggestions = [];
				}
			});

			this.$watch('products', () => {
				setTimeout(() => {
					this.getProductData();
					this.show_preloader = false;
				}, 350);
			});

			this.$watch('search_products', () => {
				setTimeout(() => {
					if (this.search_products.length === 0) {
						this.show_empty = true;
					}
				}, 500);
				this.show_empty = false;
			});

			this.$watch('query', () => {
				if (this.query.length <= 1) {
					this.results = null;
					this.show_empty = false;
					this.closed = true;
				}
			});
		},
	};
}
